import React from "react";




const Ribbon = ({text, className}) => {
  return (
    <div className="ribbon ribbon-top-right o_widget">
      <span className={className}>
        {text}
      </span>
    </div>
  )
};


export const RibbonText = ({className, text}) => {
  return (
    <span className={className}>
      {text}
    </span>
  )
};

export default Ribbon;
